import { Component, Input } from '@angular/core';
import { UtilsService } from '@services/common/utils.service';

@Component({
    selector: 'app-num-displayer',
    templateUrl: './num-displayer.component.html',
    styleUrls: ['./num-displayer.component.scss'],
    standalone: false,
})
export class NumDisplayerComponent {
    @Input() value: number = 0;
    @Input() hasReplacementValue?: string;
    @Input() factor?: number;
    @Input() simpleFormat?: boolean;
    constructor(public utilsService: UtilsService) {}
}
